import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Input } from 'antd';
import cls from 'classnames';
import { SearchOutlined } from '@ant-design/icons';
import logo from '@/assets/images/logo.png';
import styles from './index.module.scss';

export default (props: Record<string, any>) => {
  const { onSearch, hasBorder = false, defaultSearchKeyWord } = props;
  const [searchKey, setSearchKey] = useState<string>();
  const location = useLocation();
  const navigate = useNavigate();
  const searchHandle = useCallback(() => {
    console.log('searchKey===', searchKey, location.pathname);
    if (location.pathname !== '/searchPage' && searchKey) {
      navigate(`/searchPage?keyword=${searchKey}`);
      return;
    }
    onSearch?.(searchKey);
  }, [location, searchKey, onSearch]);
  const gotoIndex = useCallback(() => {
    navigate('/');
  }, []);
  const suffix = useMemo(() => {
    return <SearchOutlined className={styles['search-icon']} onClick={() => searchHandle()} />;
  }, [searchHandle]);
  useEffect(() => {
    setSearchKey(defaultSearchKeyWord);
  }, [defaultSearchKeyWord]);
  return (
    <div className={hasBorder ? cls(styles['header-waper'], styles['border-content']) : styles['header-waper']}>
      <div className={cls(styles['inner-header'], 'flex', 'v-center')}>
        <div className={cls(styles['left-header'], 'flex1', 'flex', 'v-center')}>
          <div className={styles['waper-logo']} onClick={() => gotoIndex()}>
            <img src={logo} />
          </div>
          <div className={styles['center-title']}>丹家智选商城</div>
        </div>
        <div className={cls(styles['right-header'])}>
          <Input
            placeholder=""
            className={styles['search-input']}
            suffix={suffix}
            value={searchKey}
            onPressEnter={(e) => searchHandle()}
            onInput={(e: any) => {
              console.log('e====', e.nativeEvent.target.value);
              setSearchKey(e.nativeEvent.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};
